import React from "react";
function SkillCard({ skill }) {
  return (
   <div className=" w-max py-2 px-4 flex flex-col items-center justify-center m-1 rounded-lg shadow-md">
     <div className=" text-8xl">{skill.icon}</div>
     <label className=" text-lg">{skill.name}</label>
   </div>
  );
}
export default SkillCard;